import axios from "axios";
import { store } from "../store/Store";

const BASEURL = process.env.REACT_APP_UAT_BASE_URL;
const axiosInstance = axios.create({
  baseURL: BASEURL,
});
axiosInstance.interceptors.request.use((config) => {
  const auth = store.getState().vehicledetail?.bikenum;
  // console.log("auth", auth);
  if (auth && auth?.insurance?.insurance_type === "new") {
    config.headers = {
      Authorization: `Bearer ${auth.accessToken}`,
      Accept: "application/json",
    };
  } else {
    config.headers = {
      Authorization: `Bearer ${auth.token}`,
      Accept: "application/json",
    };
  }
  return config;
});

export default axiosInstance;
